import React from 'react'
import logo from '../Assets/tme_logo.png'

const Logo = () => {
  return (
    <div className='logo-page'>
        <img className='tme-logo' src={logo} alt='TME' />
        <h2 className='tme-header'>travel made easy</h2>
    </div>
  )
}

export default Logo